import { render, staticRenderFns } from "./CallTransferIcon.vue?vue&type=template&id=7eea9a32&"
import script from "./CallTransferIcon.vue?vue&type=script&lang=js&"
export * from "./CallTransferIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports